import type { MarketExceptionType } from '../../MarketExceptionTypes'

export const CO: MarketExceptionType = {
  hasNativeCreditCard: true,
  hasStoreCredit: true,
  marketoSmsOptIn: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsStatement: false,
  currencyCode: 'COP',
  isCashMarket: true,
  creditCardProvidersSupported: ['MC', 'VI', 'AX', 'DI'],
  isWorldPay3DS: false,
  poboxRestricted: false,
  isPickupMarket: false,
  hasAddressRegion: true,
  allowShippingToExternalCountries: false,
  supportsStoreCredit: true,
  applePayOTP: false,
  applePaySubscriptions: false,
  hasPaypal: false,
  hasPaypal3DS: false,
  hasShipByDate: false,
  hasAddressValidation: false,
  allowSubscriptionPickup: false,
  hasProductAvailability: true,
  tax: {
    inclusive: true,
    noFrontendTaxCalculation: true,
    explicitlyExclusive: false,
  },
  hasZipCode: true,
  skuAvailabilityShippingMethod: 'Economy',
  defaultEconomyShippingMethod: 'Economy',
  restrictedPickupLocations: [],
  reportIssueButton: {
    show: false,
    url: {},
  },
  skuPricingOverrides: [],
}
